<template>
  <div class="analytics-page fade-in">
     <transition name="fade-slide">
      <div v-if="loading" class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    </transition>
    <!-- ===== Header ===== -->
    <div class="header-row">
      <h1 class="page-title">
        <i class="bx bx-globe"></i> {{ get_web() || "Select Page" }}
      </h1>
      <div class="filters">
      <select v-model="selectedWebsite" @change="handleWebsiteChange" class="select-theme">
        <option value="" selected="">-- Select Page --</option>

        <!-- Profiles -->
        <option v-for="web in profiles"
                :key="'p'+web.profile_id"
                :value="web.profile_id"
                data-type="profile">
          /{{ web.profile_username }}
        </option>
      </select>

        <select v-model="selectedRange" class="select-theme" @change="handleRangeChange">
          <option value="today">Today</option>
          <option value="last_7_days">Last 7 Days</option>
          <option value="last_month">Last 30 Days</option>
          <option value="last_12_months">Last 12 Months</option>
          <option value="custom">Custom Range</option>
        </select>

        <!-- Custom Date Range Inputs -->
        <div v-if="selectedRange === 'custom'" class="custom-date-range">
          <input
            type="date"
            v-model="from"
            class="select-theme"
            placeholder="From date"
          />
          <input
            type="date"
            v-model="to"
            class="select-theme"
            placeholder="To date"
          />
        </div>

        <button class="btn-primary" @click="fetchAnalytics">
          <i class="bx bx-search"></i> Search
        </button>

      </div>
    </div>
 <div class="row"
            style="
            display: flex;
            gap: 24px;
            
            flex-wrap: nowrap;
            margin-bottom: 24px;
            align-items: stretch;
            width: 100%;
            ">

        <!-- ✅ LEFT CARD (30%) -->
        <div class="left"
            style="
                flex: 0 0 30%;
                max-width: 30%;
                min-width: 280px;
                display: flex;
                flex-direction: column;
            ">
            <div class="welcome"
                style="
                background: var(--card);
                border: 1px solid var(--border);
                border-radius: var(--radius);
                padding: 1rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                gap: 12px;
                height: 12.5rem;
                box-shadow: 0 2px 6px rgba(0,0,0,0.05);
                transition: all 0.3s ease;
                ">
            <h2 v-if="ldata!=null" style="margin: 0; font-size: 1.25rem; font-weight: 600;">Welcome back, {{ ldata.fname }} 👋</h2>
            <p style="margin: 0; color: var(--muted); font-size: 0.95rem; line-height: 1.45;">
                Launch a new AI-powered page today and take your business visibility
                to the next level.
            </p>
            <button
                @click="createNewWebsite()"
                style="
                margin-top: 10px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                background: var(--primary);
                color: #fff;
                border: none;
                padding: 10px 18px;
                border-radius: 8px;
                font-size: 14px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 3px 8px rgba(17,24,39,0.2);
                height: 40px;
                ">
                <i class='bx bx-globe' style="font-size: 1.2rem;"></i>
                Create My Page
            </button>
            </div>
        </div>

        <!-- ✅ RIGHT CARD (70%) -->
        <div class="right"
            style="
                flex: 0 0 70%;
                max-width: 70%;
                display: flex;
                flex-direction: column;
            ">
            <div class="cta-card"
                style="
                background: linear-gradient(135deg, #111827, #1f2937, #374151);
                color: #fff;
                border-radius: var(--radius);
                padding: 24px 22px;
                height: 200px;
                box-shadow: 0 2px 6px rgba(0,0,0,0.05);
                display: flex;
                align-items: center;
                justify-content: space-between;
                transition: all 0.3s ease;
                cursor: pointer;
                "
                @click="goToMyPages">

            <!-- Left Text & Features -->
            <div class="cta-text" style="max-width: 70%; display: flex; flex-direction: column; gap: 6px;">
                <h2 style="font-size: 1.35rem; margin: 0; font-weight: 700;">✨ Expand Your Digital Presence</h2>
                <p style="color: #d1d5db; font-size: 1rem; line-height: 1.55; margin: 0;">
                Create and manage AI-powered pages that grow your business effortlessly.
                </p>

                <!-- ✅ New: Mini Feature List -->
                <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-top: 6px;">
                <div style="display: flex; align-items: center; gap: 6px;">
                    <i class='bx bx-rocket' style="font-size: 1rem; color: #facc15;"></i>
                    <span style="font-size: 0.85rem; color: #e5e7eb;">Faster Performance</span>
                </div>
                <div style="display: flex; align-items: center; gap: 6px;">
                    <i class='bx bx-brain' style="font-size: 1rem; color: #60a5fa;"></i>
                    <span style="font-size: 0.85rem; color: #e5e7eb;">Smart Automation</span>
                </div>
                <div style="display: flex; align-items: center; gap: 6px;">
                    <i class='bx bx-lock-alt' style="font-size: 1rem; color: #34d399;"></i>
                    <span style="font-size: 0.85rem; color: #e5e7eb;">Enterprise Security</span>
                </div>
                </div>
            </div>

            <!-- CTA Button -->
            <button class="cta-btn"
                    style="
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                        background: #fff;
                        color: #111827;
                        border: none;
                        padding: 10px 20px;
                        border-radius: 8px;
                        font-weight: 600;
                        font-size: 14px;
                        height: 40px;
                        cursor: pointer;
                        transition: all 0.3s ease;
                    ">
                <i class="bx bx-globe" style="font-size: 1.2rem;"></i>
                Go to My Pages
            </button>
            </div>
        </div>
        </div>
    <!-- ===== KPI Cards ===== -->
    <div class="kpi-row fade-in">
      <div class="kpi-card" v-for="(kpi, i) in kpis" :key="i">
        <div>
          <h4>{{ kpi.label }}</h4>
          <div class="value">{{ kpi.value }}</div>
        </div>
        <i :class="kpi.icon + ' kpi-icon'"></i>
      </div>
    </div>

    <!-- ===== Analytics Grid ===== -->
    <div class="analytics-grid">
      <!-- Left -->
      <div class="left-grid">
        <div class="chart-card fade-in">
          <h4>Your Page Progress</h4>
          <div v-if="hasData('visitors')"  id="progressChart" class="chart"></div>
          <!-- ✅ Placeholder -->
          <div v-if="!hasData('visitors')" class="empty-placeholder">
            <i class="bx bx-line-chart"></i>
            <h3>No analytics data yet</h3>
            <p>Start tracking your page to visualize traffic trends.</p>
          </div>
        </div>

        <div class="chart-card fade-in" style="margin-top: 1rem;">
          <h4>Sources Report</h4>
          <div  v-if="hasData('sources')" id="sourcesChart" class="chart"></div>
          <div v-if="!hasData('sources')" class="empty-placeholder">
            <i class="bx bx-pie-chart-alt"></i>
            <h3>No source data</h3>
            <p>When visitors arrive from search or social, data will appear here.</p>
          </div>
        </div>

        <div class="chart-card fade-in" style="margin-top: 1rem;">
          <h4>Users By Country</h4>
          <div v-if="hasData('countries')" id="mapdiv" class="mapchart"></div>
          <div v-if="!hasData('countries')" class="empty-placeholder">
            <i class="bx bx-world"></i>
            <h3>No location data</h3>
            <p>Track your global audience once traffic begins flowing in.</p>
          </div>
        </div>
      </div>

      <!-- Right -->
      <div class="right-grid">
        <div class="realtime-card fade-in">
          <div class="realtime-header">
            <i class="bx bx-pulse"></i>
            <h4 style="color: #fff;">Realtime Visitors</h4>
          </div>
          <div class="realtime-value">{{ realtimeVisitors }}</div>
          <p class="text-muted" style="color: #fff;">Currently active on your pages</p>
        </div>

        <div class="card fade-in" style="margin-top: 1rem;">
          <h4>Top Referrers</h4>
          <ul>
            <li v-for="(ref, i) in referrers" :key="i">
              <span><i class="bx bx-link"></i> {{ ref.name }}</span>
              <span class="count">{{ ref.count }}</span>
            </li>
          </ul>
          <div v-if="referrers.length === 0" class="empty-placeholder small">
            <i class="bx bx-network-chart"></i>
            <h3>No referrers found</h3>
            <p>Referral data will show up once visitors arrive via links.</p>
          </div>
        </div>

        <div class="chart-card fade-in" style="margin-top: 1rem;">
          <h4>Users by Device</h4>
          <div v-if="hasData('devices')"  id="deviceChart" class="chart"></div>
          <div v-if="!hasData('devices')" class="empty-placeholder">
            <i class="bx bx-mobile-alt"></i>
            <h3>No device data</h3>
            <p>Track desktop, mobile & tablet usage here.</p>
          </div>
        </div>

        <div class="chart-card fade-in" style="margin-top: 1rem;">
          <h4>Conversion Funnel</h4>
          <div v-if="hasData('funnel')" id="funnelChart" class="chart"></div>
          <div v-if="!hasData('funnel')" class="empty-placeholder">
            <i class="bx bx-transfer"></i>
            <h3>No conversion data</h3>
            <p>Monitor how visitors move from views to leads to sales.</p>
          </div>
        </div>
      </div>
    </div>
    <br><br><br>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/worldLow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { useToast } from "vue-toastification";
import { getProfiles } from "@/apis/profileapi";
import { getAnaReport } from "@/apis/adminapis";


export default {
  name: "AnalyticsPage",
  data() {
    return {
      toast: useToast(),
      userId:"",
      from:"",
      ldata:null,
      to:"",
      profiles:[],
      loading:false,
      selectedWebsite: "",
      rtype:"0",
      selectedRange: "last_month",
      realtimeVisitors: 0,
      kpis: [
        { label: "Unique Visitors", value: "0", icon: "bx bx-user" },
        { label: "Total Visits", value: "0", icon: "bx bx-show" },
        { label: "Total Pageviews", value: "0", icon: "bx bx-bar-chart-alt" },
        { label: "Views Per Visit", value: "0", icon: "bx bx-line-chart" },
        { label: "Bounce Rate", value: "0%", icon: "bx bx-trending-down" },
        { label: "Visit Duration", value: "0s", icon: "bx bx-timer" },
      ],
      referrers: [
        { name: "Direct / None", count: 0 },
        { name: "Google", count: 0 },
        { name: "Facebook", count: 0 },
        { name: "LinkedIn", count: 0 },
      ],
      // countries: [
      //   { id: "US", name: "United States", visitors: 0 },
      //   { id: "IN", name: "India", visitors: 0 },
      //   { id: "GB", name: "United Kingdom", visitors: 0 },
      //   { id: "DE", name: "Germany", visitors: 0 },
      //   { id: "CA", name: "Canada", visitors: 0 },
      // ],
      chartData: {
      visitors:[],
      timeseries: [],
      sources: [],
      devices: [],
      countries: [],
      funnel: [],
      overview: {},
    },
    };
  },
  mounted() {
     const ldataRaw = sessionStorage.getItem("ldata");
      this.ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
      if (!this.ldata) {
        window.location.href = "/login";
        return;
      }

      this.userId = this.ldata.user_id;
      this.loadProfiles();

  },
  methods: {
    processAnalytics(data) {
  // === KPIs ===
  this.kpis = [
    { label: "Unique Visitors", value: data.overview.unique_visitors || 0 },
    { label: "Total Visits", value: data.overview.total_visits || 0 },
    { label: "Total Pageviews", value: data.overview.total_pageviews || 0 },
    { label: "Views Per Visit", value: data.overview.views_per_visit || 0 },
    { label: "Bounce Rate", value: (data.overview.bounce_rate || 0) + "%" },
    { label: "Visit Duration", value: data.overview.visit_duration || "0s" },
  ];

  // === CORRECT CHART DATA MAPPING (same as working dashboard) ===
  this.chartData = {
    visitors: data.timeseries_events || [],
    sources: data.sources || [],
    devices: data.devices || [],
    countries: data.countries || [],
    funnel: data.sources1 || [],
  };

  // === Referrers ===
  this.referrers = this.chartData.sources.map((s) => ({
    name: s.source,
    count: s.visitors,
  }));

  // === Realtime visitors ===
  this.realtimeVisitors = data.realtime_visitors || 0;

  // === Render charts ===
  this.$nextTick(() => {
    this.renderCharts();
    this.renderMap();
  });
}
,

    handleRangeChange() {
      if (this.selectedRange !== "custom") {
        this.from = "";
        this.to = "";
      }
    },
   handleWebsiteChange(event) {
      // Selected ID from v-model
      const id = this.selectedWebsite;

      if (!id) return;

      // Get selected option element
      const selectedOption = event.target.options[event.target.selectedIndex];
      const type = selectedOption.getAttribute("data-type");
     
      if (type === "website") {
        this.rtype = "0";   // For website
      } 
      else if (type === "profile") {
        this.rtype = "1";   // For profile
      }
    }
    ,
    hasData(type) {
      if (!this.chartData) return false;

      switch (type) {
        case "visitors":
          return Array.isArray(this.chartData.visitors) && this.chartData.visitors.length > 0;

        case "timeseries":
          return Array.isArray(this.chartData.visitors) && this.chartData.visitors.length > 0;
        case "sources":
          return Array.isArray(this.chartData.sources) && this.chartData.sources.length > 0;
        case "countries":
          return Array.isArray(this.chartData.countries) && this.chartData.countries.length > 0;
        case "devices":
          return Array.isArray(this.chartData.devices) && this.chartData.devices.length > 0;
        case "funnel":
          return Array.isArray(this.chartData.funnel) && this.chartData.funnel.length > 0;
        default:
          return false;
      }
    },

    async fetchAnalytics() {
        if (!this.selectedWebsite || this.selectedWebsite === "0") {
          this.toast.error("Please select a page");
          return;
        }

        this.loading = true;
        try {
          const res = await getAnaReport(this.selectedWebsite, this.selectedRange, this.from, this.to,this.rtype);

          if (res.status && res.report_dt) {
            const data = res.report_dt;
            this.processAnalytics(data);
            

           
          } else {
            this.toast.error(res.success || "No data found for this page");
          }
        } catch (error) {
          console.error("fetchAnalytics error:", error);
          this.toast.error("No data found for this page");
        } finally {
          this.loading = false;
        }
      },

    get_web(){
     
      for(var x=0;x<this.profiles.length;x++){
        if(this.profiles[x].profile_id===this.selectedWebsite){
          return this.profiles[x].profile_username;
        }
      }

      return "Select Page";
    },
    createNewWebsite(){
      window.location.href = "/my_pages";
    },
   
     async loadProfiles() {
      try {
        const res = await getProfiles(this.userId, "none", "");
        if (res?.status) {
          this.profiles = res.records || [];
          if(this.profiles!=null && this.profiles.length>0){
            this.selectedWebsite = this.profiles[0].profile_id;
            this.fetchAnalytics();
          }
        } else {
          this.profiles = [];
        }
      } catch (err) {
        console.error("Page Load Error:", err);
      }
    },
    goToMyPages(){
      window.location.href = "/my_pages";
    },
    renderCharts() {
  try {
    // 🔹 Clear old charts before re-rendering
    document.querySelectorAll(".apexcharts-canvas").forEach((el) => el.remove());

    /* ============================
       1️⃣ Page Progress (Line)
    ============================= */
    // const timeseries = this.chartData.visitors || [];
    // const dates = timeseries.map(x => x.date || "");
    // const visitors = timeseries.map(x => x.visitors || 0);

   const today = new Date();
      const tenDaysAgo = new Date();
      tenDaysAgo.setDate(today.getDate() - 9);

    let endBaseDate;

    // 👉 If custom filter active
    if (this.from && this.to) {
      endBaseDate = new Date(this.to);
    } 
    // 👉 Otherwise today
    else {
      endBaseDate = new Date();
    }

    const dailyData = [];

    for (let i = 9; i >= 0; i--) {

      const d = new Date(endBaseDate);
      d.setDate(endBaseDate.getDate() - i);

      const dateStr = d.toISOString().slice(0, 10);

      const found = this.chartData.visitors.find(v => v.date === dateStr);

      dailyData.push({
        date: dateStr,
        visitors: found ? found.visitors : 0
      });

    }

    this.chartData.last10Days = dailyData;



      const months = this.chartData.last10Days.map(d => {
      const date = new Date(d.date);
      return date.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short"
      }).replace(",", "");
    });

      const monthVisitors = this.chartData.last10Days.map(d => d.visitors);


      new ApexCharts(document.querySelector("#progressChart"), {
        chart: { type: "line", height: 250, toolbar: { show: false } },
        series: [{ name: "Visitors", data: monthVisitors.length ? monthVisitors : [0] }],
        xaxis: { categories: months.length ? months : ["Jan"] },
        stroke: { curve: "smooth", width: 3 },
        colors: ["#111827"], // 🔵 Blue
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            gradientToColors: ["#111827"], // lighter blue for gradient
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 90, 100],
          },
        },
        grid: { borderColor: "#f3f4f6" },
      }).render();


    /* ============================
       2️⃣ Sources Report (Vertical Bar)
    ============================= */
    const sources = this.chartData.sources || [];
    const sourceNames = sources.map(x => x.source);
    const sourceVisits = sources.map(x => x.visitors);

    new ApexCharts(document.querySelector("#sourcesChart"), {
      chart: { type: "bar", height: 250, toolbar: { show: false } },
      series: [{ name: "Visitors", data: sourceVisits }],
      xaxis: { categories: sourceNames },
      colors: ["#1f2937"],
      plotOptions: { bar: { borderRadius: 5, horizontal: false } }
    }).render();

    /* ============================
       3️⃣ Device Chart (Donut)
    ============================= */
    const devices = this.chartData.devices || [];
    const deviceLabels = devices.map(x => x.browser);
    const deviceCounts = devices.map(x => x.visitors);

    new ApexCharts(document.querySelector("#deviceChart"), {
      chart: { type: "donut", height: 250 },
      series: deviceCounts.length ? deviceCounts : [60, 25, 15],
      labels: deviceLabels.length ? deviceLabels : ["Desktop", "Mobile", "Tablet"],
      colors: ["#111827", "#4b5563", "#9ca3af"],
      legend: { position: "bottom" },
      dataLabels: { enabled: false },
      stroke: { width: 0 }
    }).render();

    /* ============================
       4️⃣ Conversion Funnel
       (Visitors → Leads → Conversions)
    ============================= */
   const MAX_LABEL_LENGTH = 10;

const funnelData = this.chartData.funnel.map((f) => {
  let label = f.page || "Unknown";

  // 🔹 Limit text length
  if (label.length > MAX_LABEL_LENGTH) {
    label = label.substring(0, MAX_LABEL_LENGTH) + "...";
  }

  return {
    x: label,
    y: f.visitors || 0,
  };
});
      new ApexCharts(document.querySelector("#funnelChart"), {
        chart: { type: "bar", height: 380, toolbar: { show: false } },
        plotOptions: {
          bar: { horizontal: true, borderRadius: 6, barHeight: "70%" },
        },
        series: [{ data: funnelData.length ? funnelData : [{ x: "Visitors", y: 0 }] }],
        colors: ["#111827"],
        dataLabels: { enabled: true },
        grid: { borderColor: "#111827" },
        tooltip: { theme: "light" },
      }).render();

  } catch (error) {
    console.error("renderCharts() error:", error);
  }
}
,

    renderMap() {
  try {
    am5.ready(() => {

      // 🔹 Destroy existing map instance
      const oldRoot = am5.registry.rootElements.find(r => r.dom.id === "mapdiv");
      if (oldRoot) oldRoot.dispose();

      const root = am5.Root.new("mapdiv");
      root.setThemes([am5themes_Animated.new(root)]);

      const chart = root.container.children.push(
        am5map.MapChart.new(root, {
          projection: am5map.geoMercator()
        })
      );

      const polygonSeries = chart.series.push(
        am5map.MapPolygonSeries.new(root, {
          geoJSON: am5geodata_worldLow
        })
      );

      /* ============================
         Build Country → Visitors Map
      ============================= */
      const countries = this.chartData.countries || [];
      const visitorMap = {};
      countries.forEach(c => {
        visitorMap[c.country] = c.visitors;
      });

      const max = Math.max(...Object.values(visitorMap), 1);
      const minColor = am5.color(0xcbd5e1);
      const maxColor = am5.color(0x111827);

      polygonSeries.mapPolygons.template.setAll({
        tooltipText: "{name}: {value}",
        interactive: true
      });

      /* ============================
         Correct Polygon Data
      ============================= */
      polygonSeries.data.setAll(
        countries.map(c => ({
          id: c.country,
          name: c.country,
          value: c.visitors || 0
        }))
      );

      /* ============================
         Dynamic Country Coloring
      ============================= */
      polygonSeries.mapPolygons.template.adapters.add("fill", (fill, target) => {
        const id = target.dataItem?.dataContext?.id;
        const value = visitorMap[id];

        if (value) {
          const ratio = value / max;
          return am5.Color.interpolate(minColor, maxColor, ratio);
        }

        return am5.color(0xf3f4f6);
      });

    });
  } catch (error) {
    console.error("renderMap() error:", error);
  }
}
,

  },
};
</script>

<style scoped>
.fade-in { animation: fadeInUp 0.5s ease forwards; opacity: 0; transform: translateY(10px); }
@keyframes fadeInUp { to { opacity: 1; transform: translateY(0); } }

.header-row { display: flex; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin-bottom: 20px; }
.page-title { font-size: 1.2rem; font-weight: 600; color: var(--text); display: flex; align-items: center; gap: 8px; }
.filters { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.select-theme { padding: 8px 12px; border: 1px solid var(--border); border-radius: 8px; font-size: 13px; color: var(--muted); }
.btn-primary { background: var(--primary); color: #fff; border: none; border-radius: 8px; padding: 8px 16px; font-size: 13px; }
.btn-primary:hover { background: var(--primary-dark); }

/* === KPI Cards === */
.kpi-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 16px; margin-bottom: 24px; }
.kpi-card {
  background: #fff;
  color: #111827;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.kpi-card h4 { font-size: 13px; color: #6b7280; }
.kpi-card .value { font-size: 20px; font-weight: 700; color: #111827; }
.kpi-icon { font-size: 1.6rem; color: #9ca3af; }

/* === AI Banner === */
.ai-banner {
  background: linear-gradient(135deg, #111827, #1f2937);
  color: #fff;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.btn-gradient { background: #fff; color: #111827; border: none; border-radius: 8px; padding: 8px 16px; font-weight: 600; }
.banner-img { width: 320px; height: auto; border-radius: 8px; }

/* === Analytics Grid === */
.analytics-grid { display: grid; grid-template-columns: 70% 28%; gap: 20px; }
.chart-card, .card, .realtime-card { background: #fff; border: 1px solid var(--border); border-radius: 10px; padding: 16px; box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); }

/* === Charts === */
.chart { height: 250px; width: 100%; }
.mapchart { height: 300px; width: 100%; }

/* === Realtime Visitors === */
.realtime-card { text-align: center; background: linear-gradient(135deg, #111827, #1f2937, #374151); color: #fff;}
.realtime-header { display: flex; align-items: center; justify-content: center; gap: 6px; font-weight: 600; color: #fff; }
.realtime-value { font-size: 2.5rem; font-weight: 700; color: #fff; margin: 8px 0; }
.text-muted { color: #6b7280; font-size: 13px; }

/* === Referrers === */
.card ul { list-style: none; padding: 0; }
.card li { display: flex; justify-content: space-between; border-bottom: 1px dashed var(--border); padding: 6px 0; font-size: 13px; }
.count { font-weight: 600; color: #111827; }

/* === Call to Action (CTA) Card === */
.cta-card {
  grid-column: span 12 / span 12;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(135deg, #111827, #1f2937, #374151);
  position: relative;
  padding: 2rem 2.5rem;
  margin-bottom: 1.5rem;
  color: #f9fafb;
  cursor: pointer;
  transition: all 0.4s ease;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
}

.cta-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top left, rgba(255, 255, 255, 0.1), transparent 70%);
  z-index: 0;
  opacity: 0.4;
  transition: opacity 0.3s ease;
}

.cta-card:hover::before {
  opacity: 0.6;
}

.cta-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.cta-text h2 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0.5rem;
  letter-spacing: 0.3px;
}

.cta-text p {
  color: #d1d5db;
  font-size: 0.95rem;
  max-width: 540px;
  line-height: 1.6;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  color: #111827;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.15);
}

.cta-btn i {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.cta-btn:hover {
  background: #f3f4f6;
  transform: translateY(-2px);
}

.cta-btn:hover i {
  transform: translateX(4px);
}

/* === Hover Animation (Card) === */
.cta-card:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 14px 35px rgba(17, 24, 39, 0.4);
}

/* === Responsive === */
@media (max-width: 768px) {
  .cta-content {
    flex-direction: column;
    text-align: center;
  }

  .cta-text p {
    max-width: 100%;
  }
}

/* 📱 MOBILE RESPONSIVENESS PATCH — Do NOT remove anything above this */
@media (max-width: 1024px) {
  /* Stack main hero row vertically */
  .row {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 16px !important;
  }

  .left,
  .right {
    flex: 1 1 100% !important;
    max-width: 100% !important;
    min-width: unset !important;
  }

  .welcome,
  .cta-card {
    height: auto !important;
    padding: 20px !important;
  }

  .cta-card {
    flex-direction: column !important;
    text-align: center !important;
    gap: 16px !important;
  }

  .cta-text {
    max-width: 100% !important;
    text-align: center !important;
  }

  .cta-btn {
    width: 100% !important;
    justify-content: center !important;
  }

  /* Analytics grid: 1 column stack */
  .analytics-grid {
    grid-template-columns: 1fr !important;
    gap: 18px !important;
  }

  .chart-card,
  .card,
  .realtime-card {
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  /* Filters stack vertically */
  .filters {
    flex-direction: column !important;
    width: 100% !important;
    gap: 8px !important;
  }

  .filters select,
  .filters button {
    width: 100% !important;
    font-size: 14px !important;
    padding: 10px 14px !important;
  }

  .page-title {
    font-size: 1.1rem !important;
    text-align: center !important;
    width: 100% !important;
  }

  .header-row {
    flex-direction: column !important;
    align-items: center !important;
    text-align: center !important;
  }

  /* KPI grid adjusts */
  .kpi-row {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)) !important;
    gap: 12px !important;
  }

  /* Charts full width */
  .chart {
    height: 220px !important;
  }

  /* Referrers list readability */
  .card li {
    font-size: 12.5px !important;
    flex-wrap: wrap !important;
  }

  /* Realtime card */
  .realtime-value {
    font-size: 2rem !important;
  }

  /* Buttons */
  .welcome button,
  .cta-btn {
    width: 100% !important;
    justify-content: center !important;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 1rem !important;
  }

  .welcome h2,
  .cta-text h2 {
    font-size: 1.1rem !important;
  }

  .welcome p,
  .cta-text p {
    font-size: 0.9rem !important;
    line-height: 1.45 !important;
  }

  .filters select,
  .filters button {
    font-size: 13px !important;
  }

  .kpi-card {
    padding: 12px !important;
  }

  .kpi-card .value {
    font-size: 18px !important;
  }

  .cta-card,
  .welcome {
    padding: 18px !important;
  }

  .mini-features div {
    width: 100% !important;
    justify-content: center !important;
  }
}
/* 📊 CHART RESPONSIVE FIX */
@media (max-width: 1024px) {
  /* Ensure parent grid never overflows */
  .analytics-grid {
    display: flex !important;
    flex-direction: column !important;
    gap: 18px !important;
    overflow: hidden !important;
    width: 100% !important;
  }

  /* Each chart container should fit parent width */
  .chart-card,
  .chart,
  .apexcharts-canvas {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
  }

  /* Force chart canvas scaling inside */
  .apexcharts-canvas svg {
    width: 100% !important;
    height: auto !important;
  }

  /* Prevent margin spill or misalignment */
  .left-grid,
  .right-grid {
    width: 100% !important;
    margin: 0 auto !important;
  }

  /* Ensure scroll doesn’t appear */
  html,
  body,
  .analytics-page {
    overflow-x: hidden !important;
  }
}

@media (max-width: 768px) {
  /* Tighten inner chart card padding for small screens */
  .chart-card {
    padding: 12px !important;
  }

  .chart {
    height: 220px !important;
    width: 100% !important;
  }

  .apexcharts-canvas {
    width: 100% !important;
    height: auto !important;
  }

  .apexcharts-canvas svg {
    width: 100% !important;
    height: auto !important;
  }
}

@media (max-width: 480px) {
  /* Even smaller scaling for narrow devices */
  .chart {
    height: 200px !important;
  }

  .chart-card {
    padding: 10px !important;
  }
}

/* === 📊 EMPTY STATE PLACEHOLDERS === */
.empty-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 220px;
  border: 1px dashed var(--border);
  border-radius: 10px;
  background: #fafafa;
  margin-top: 10px;
  animation: fadeIn 0.4s ease;
}

.empty-placeholder i {
  font-size: 2.4rem;
  color: var(--muted);
  margin-bottom: 6px;
  opacity: 0.8;
}

.empty-placeholder h3 {
  font-size: 1rem;
  color: var(--text);
  font-weight: 600;
  margin-bottom: 4px;
}

.empty-placeholder p {
  font-size: 13px;
  color: var(--muted);
  max-width: 240px;
  line-height: 1.4;
}

.empty-placeholder.small {
  height: 160px;
  background: #fcfcfc;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Responsive balance for smaller devices */
@media (max-width: 768px) {
  .empty-placeholder {
    height: 180px !important;
    padding: 10px !important;
  }
  .empty-placeholder i {
    font-size: 2rem !important;
  }
  .empty-placeholder p {
    font-size: 12.5px !important;
  }
}


</style>
